class FnTag {
  constructor() {
  }

  parseUrl(app) {
    const {route} = app.context;
    let id = route.params.id;
    let tempParams = {
      page: 1,
      lastId: 0
    }
    if (!!id) {
      /* 去除.HTML后缀 */
      id = id.replace('.html', '');
      let ids = id.split('-')
      if (ids.length == 2) {
        tempParams.page = ids[0]
        tempParams.lastId = ids[1]
      } else {
        tempParams.page = ids[0]
      }
    }
    return tempParams;
  }
}

export default new FnTag();
